const MARKER = '/img/'

/**
 * Reescribe la URL del original (/img/...) a un derivado WebP.
 * Si no reconoce la URL, devuelve el original para no dejar la card sin foto.
 */
export function imagenTienda (src, ancho) {
  if (!src || typeof src !== 'string') return src
  if (src.indexOf('/api/imagenes/') !== -1) return src
  if (src.indexOf('noimage_Producto') !== -1) return src
  const i = src.toLowerCase().indexOf(MARKER)
  if (i < 0) return src
  const base = src.slice(0, i)
  const rel = src.slice(i + MARKER.length).split('?')[0].split('#')[0]
  if (!rel) return src
  return base + '/api/imagenes/' + ancho + '/' + rel
}

export function imagenCard (src) {
  return imagenTienda(src, 480)
}

export function imagenFicha (src) {
  return imagenTienda(src, 960)
}
